import React, { useEffect, useState, createContext, useContext } from 'react';
import { generateHarmoniosColors } from '../utils/colorUtils';
interface ColorContextType {
  colors: {
    primary: string;
    secondary: string;
  };
}
const ColorContext = createContext<ColorContextType | undefined>(undefined);
export const ColorProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Force color regeneration on each mount
  const [colors, setColors] = useState(generateHarmoniosColors);
  // Update colors when pathname changes
  useEffect(() => {
    setColors(generateHarmoniosColors());
  }, [window.location.pathname]);
  return <ColorContext.Provider value={{
    colors
  }} data-id="element-260">
      {children}
    </ColorContext.Provider>;
};
export const useColors = () => {
  const context = useContext(ColorContext);
  if (!context) {
    throw new Error('useColors must be used within a ColorProvider');
  }
  return context;
};